import { useRef } from 'react'

import { Background, ModalWrapper, Button } from './styles'

const ChangePaymentModal = ({
  showModal,
  setShowModal,
  handleSubmitCredit,
  handleSubmitBoleto,
  formaPagamento,
  setConfirmChange
}) => {
  const modalRef = useRef()

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false)
    }
  }

  return (
    <>
      {showModal ? (
        <Background onClick={closeModal}>
          <ModalWrapper>
            <div className="title">
              <h2 className="modal-title">Alterar Pagamento</h2>
            </div>
            <p className="modal-description">
              Confirmar alteração dos dados de pagamento para{' '}
              <strong>{formaPagamento}</strong>?
            </p>
            <div className="button-container">
              <Button
                onClick={() => {
                  if (formaPagamento.includes('Boleto')) {
                    handleSubmitBoleto()
                  } else {
                    setConfirmChange(true)
                    // handleSubmitCredit()
                  }
                  setShowModal((prev) => !prev)
                }}
              >
                Confirmar
              </Button>
              <Button
                className="button-outline"
                onClick={() => {
                  setConfirmChange(false)
                  setShowModal((prev) => !prev)
                }}
              >
                Cancelar
              </Button>
            </div>
          </ModalWrapper>
        </Background>
      ) : null}
    </>
  )
}

export default ChangePaymentModal
